import "./App.css";
import { createHashRouter, RouteObject, RouterProvider, Outlet } from "react-router";
import { Journey } from "@forms/components/Journey";
import { Header } from "./components/Header";
import { Toaster } from "@shadcn/components/ui/toaster";
import { useEffect } from "react";
import { applyTheme } from "@forms/form-render/helpers/applyTheme";

const Layout = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="px-0 sm:px-2">
        <Outlet />
      </main>
    </div>
  );
};

export const routes = (): RouteObject[] => {
  return [
    {
      element: <Layout />,
      children: [
        { path: "/", element: <Journey /> },
        { path: "/:stepId", element: <Journey /> },
      ],
    },
  ];
};

function App() {
  const router = createHashRouter(routes());

  useEffect(() => {
    applyTheme();
    const timeoutId = setTimeout(() => {
      applyTheme();
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
}

export default App;
